import Nullstack from 'nullstack';
export default function IconBiohazardOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-biohazard-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M10.586 10.586a2 2 0 1 0 2.836 2.82"
  }), "   ", Nullstack.element("path", {
    d: "M11.939 14c0 .173 .048 .351 .056 .533v.217a4.75 4.75 0 0 1 -4.533 4.745h-.217"
  }), "   ", Nullstack.element("path", {
    d: "M2.495 14.745a4.75 4.75 0 0 1 7.737 -3.693"
  }), "   ", Nullstack.element("path", {
    d: "M16.745 19.495a4.75 4.75 0 0 1 -4.69 -5.503h-.06"
  }), "   ", Nullstack.element("path", {
    d: "M14.533 10.538a4.75 4.75 0 0 1 6.957 3.987v.217"
  }), "   ", Nullstack.element("path", {
    d: "M10.295 10.929a4.75 4.75 0 0 1 -2.988 -3.64m.66 -3.324a4.75 4.75 0 0 1 .5 -.66l.164 -.172"
  }), "   ", Nullstack.element("path", {
    d: "M15.349 3.133a4.75 4.75 0 0 1 -.836 7.385"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}